module.exports = __webpack_public_path__ + "img/winner.0faf1e4d.png";